import React, { useEffect, useState } from "react";
import {
  TextField,
  Typography,
  Box,
  TableContainer,
  Paper,
  Button,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import DynamicTable from "../../../Common/DynamicTable";
import {
  validateLeadershipTable,
  validateTable,
} from "../../../../utils/validateTable";
import { get, put } from "../../../../utils/api";
import style from "../../../../styles/brsr/general.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { restructureData } from "../../../../utils/restructureData";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const LeadershipIndicator = ({ onSave, hide, removeUpload = false }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [modalupload, setModalUpload] = useState({
    publicPolicyPositionsDoc: false,
  });
  const [formData, setFormData] = useState({
    publicPolicyPositionsDoc: [],
  });
  const [tables, setTables] = useState([
    {
      fieldName: "publicPolicyPositions",
      rows: [
        {
          informationInPublicDomain: "Yes",
          policyAdvocated: "",
          advocacyMethod: "",
          reviewFrequencyByBoard: "",
          webLink: "",
        },
      ],
    },
  ]);
  const [errors, setErrors] = useState({});

  const inputData = [
    {
      fieldName: "publicPolicyPositions",
      title: "1. Details of public policy positions advocated by the entity:",
      type: "array",
      fields: [
        {
          fieldName: "policyAdvocated",
          title: "Public policy advocated",
          placeholder: "Type Here",
          type: "text",
          width: "5rem",
        },
        {
          fieldName: "advocacyMethod",
          title: "Method resorted for such advocacy",
          placeholder: "Enter Text",
          type: "text",
          width: "8rem",
        },
        {
          fieldName: "informationInPublicDomain",
          title: "Whether information available in public domain? (Yes / No)",
          // value: "Yes",
          type: "select",
          width: "7rem",
          options: ["Yes", "No"],
        },
        {
          fieldName: "reviewFrequencyByBoard",
          title: "Frequency of Review by Board",
          placeholder: "Type Here",
          type: "text",
          width: "10rem",
        },
        {
          fieldName: "webLink",
          title: "Web Link, if available",
          placeholder: "Type Here",
          type: "text",
          width: "5rem",
        },
      ],
    },
  ];

  const [data, setData] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(
        `/brsr/get?subType=principle7&type=SectionC&id=${id}`
      );
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);

      const res1 =
        res?.data?.data?.BRSRSectionC?.principle7?.leadershipIndicator;
      setData(res1);
      setFormData({
        publicPolicyPositionsDoc: res1?.publicPolicyPositionsDoc ?? [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let transformedData = restructureData(tables);
      let v1 = validateLeadershipTable(inputData, tables, setErrors);
      if (!v1) return;

      transformedData = {
        leadershipIndicator: {
          ...transformedData,
          ...formData,
        },
        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle7",
      };
      await put(`/brsr/update?id=${id}`, transformedData)
        .then(
          (res) => res.response === 200 && onSave(),
          navigate(`/brsr/section-c/principle8/${id}`)
        )
        .catch((err) => {});
      if (!validateTable(inputData, tables, setErrors)) return;
    } else navigate(`/brsr/section-c/principle8/${id}`);
  };
  return (
    <div>
      <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>

      <DynamicTable
        {...{
          inputData,
          handleSubmit,
          tables,
          setTables,
          errors,
          setErrors,
          data,
          disabled,
          hide,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "publicPolicyPositionsDoc",
          ml: 2.5,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98.5%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </div>
  );
};

export default LeadershipIndicator;
